import store from '@/store'

const MIN_JWT_LENGTH = 20

export function tieneAccessTokenRh() {
  const t = localStorage.getItem('accessToken') || localStorage.getItem('tlaKey')
  return typeof t === 'string' && t.trim().length >= MIN_JWT_LENGTH
}

/**
 * Alinea Vuex y localStorage: no permitir "sesión" sin JWT ni JWT huérfano sin sesión.
 * Debe ejecutarse al arrancar la app y al inicio de cada navegación.
 */
export function alinearSesionJwt() {
  const sesion = store.state.login.login
  const tokenOk = tieneAccessTokenRh()

  if (sesion && !tokenOk) {
    store.dispatch('login/salirLogin')
    return
  }

  if (!sesion && tokenOk) {
    localStorage.removeItem('accessToken')
    localStorage.removeItem('tlaKey')
  }
}
